import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import markdownit from 'markdown-it';
import 'github-markdown-css/github-markdown.css'
import axios from 'axios';
import { BContainer,BButton,BRow,BCol } from "bootstrap-vue-next";
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';

export default {
  name: 'TermsOfService',
  components: {
    Loading,BContainer,BButton,BRow,BCol,LanguageSwitcher
  },

  // 共通関数
  //mixins: [netutils],

  // ローカルデータ変数
  data() {
    return {
      // メッセージ
      message: {
        is_alert: false,
        variant: "",
        message: "",
      },
      // ローディング
      loader: {
        is_loading: false,
        is_full_page: true,
      },
      // バインドデータ
      bind_data: {
        markdownit: null, //マークダウンオブジェクト
        markdowntext: "", //HTML化したテキスト
      },
      // ローカルデータ
      local_data: {
        markdowntext: "",
      },
      // 状態データ
      state_data: {
        is_header_footer: true
      }
    }
  },

  // 既定計算
  computed: {
  },

  // インスタンス初期化後
  created: function(){
    this.bind_data.markdownit = new markdownit();
  },
  // インスタンス破棄後
  beforeUnmount: function() {
    window.removeEventListener('locale-changed', this.onLocaleChanged);
  },
  // インスタンスマウント後
  mounted: async function(){
    let href = window.location.href;
    console.log("TermsOfService:href="+href);
    let url = window.location.search;
    console.log("TermsOfService:url="+url);
    let params = new URLSearchParams(url);
    console.log("TermsOfService:"+params);
    if( params.get("from") === "skill" || params == "from=skill" ){
      this.state_data.is_header_footer = false;
    }

    window.addEventListener('locale-changed', this.onLocaleChanged);
    await this.loadMarkdown();
  },

  // ローカル関数
  methods: {
    async loadMarkdown() {
      this.loader.is_loading = true;
      const locale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'ja';
      const path = `/markdown/${locale}/terms_of_service.md`;
      try {
        const res = await axios.get(path);
        this.local_data.markdowntext = res;
        this.bind_data.markdowntext = this.bind_data.markdownit.render(res.data);
      } catch (e) {
        console.error("Failed to load markdown from " + path, e);
        try {
          const fallbackRes = await axios.get("/terms_of_service.md");
          this.bind_data.markdowntext = this.bind_data.markdownit.render(fallbackRes.data);
        } catch (err) {
          console.error("Fallback markdown load failed", err);
        }
      } finally {
        this.loader.is_loading = false;
      }
    },
    async onLocaleChanged() {
      await this.loadMarkdown();
    },
    home(){
      // 画面遷移
      this.$router.push({ path:'/Home' });
    },
    qa(){
      // 画面遷移
      this.$router.push({ path:'/QA' });
    },
    privacy_policy(){
      // 画面遷移
      this.$router.push({ path:'/PrivacyPolicy' });
    },
    terms_of_service(){
      // 画面遷移
      this.$router.push({ path:'/TermsOfService' });
    },
  }
}
